var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTransportationIndustry(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.743 20.816h9.759c1.105-3.253 5.716-3.222 6.81 0h.815v-4.69c0-.584-.479-1.063-1.063-1.063h-7.19a.938.938 0 01-.938-.937V8.499H4.868v1.125h1.724c1.235 0 1.235 1.875 0 1.875H4.868v1.814H9.37c1.235 0 1.235 1.875 0 1.875H4.868v5.627h1.066c1.104-3.253 5.715-3.221 6.81 0zM2.993 11.5H1.866c-1.235 0-1.235-1.876 0-1.876h1.125V7.56c0-.518.42-.938.938-.938 1.435 0 17.21.006 17.21 0 2.567 0 4.803 1.27 6.12 3.48l1.838 3.085a2.943 2.943 0 012.905 2.938v5.627c0 .518-.42.938-.938.938H29.43a3.597 3.597 0 01-7.046 0H12.86a3.597 3.597 0 01-7.046 0H3.93a.938.938 0 01-.938-.938V18.94H.93c-1.235 0-1.235-1.876 0-1.876h2.063v-1.876H.93c-1.235 0-1.235-1.875 0-1.875h2.063v-1.814zm24.13 9.256a1.72 1.72 0 010 2.432c-1.08 1.08-2.936.312-2.936-1.216 0-1.527 1.856-2.296 2.936-1.216zm-.202-7.568h-4.109V8.753c1.197.383 2.175 1.188 2.842 2.309l1.267 2.126zm-16.367 7.568a1.72 1.72 0 010 2.432c-1.08 1.08-2.935.312-2.935-1.216 0-1.527 1.855-2.296 2.935-1.216z",
    fill: "#ADC6FF"
  })));
}

export default __webpack_public_path__ + "./fonts/transportation-industry.bb995dd2f0f538e08c6bffb0d835115b.svg";
export { SvgTransportationIndustry as ReactComponent };